export enum CardBrand{
	VISA = 1,
	MASTERCARD = 2,
	AMERICAN_EXPRESS = 3,
	OTHER = 99,
}

export interface PaymentData{
	payment_id: number,
	paid: boolean,
	cancelled: boolean,
	cancel_reason: number,
	client_id: number,
	total: number,
	redirect: string,
	currency: string,
	order_id: string,
	charging: boolean,
	interval?: number,
	card: {
		card_last4: number,
		card_brand: CardBrand,
	},
	bank_id?: number,
	payload: {
		method: string,
		url: string,
		data: {
			[x: string]: string,
		}
	}
}

export interface APIResponse<T=any>{
	error: boolean,
	code: string,
	message: string,
	data?: T & { [x: string]: any },
}

export interface PaymentSocketData{
	paid: boolean,
	cancelled: boolean,
	cancel_reason: number,
	redirect: string,
}

export {}